import { Breadcrumb } from "react-bootstrap";
import RoleForm from "./Form";
import { Link } from "react-router-dom";

const EditRole = () => {
  return (
    <div>
      <h1>Edit Role</h1>
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/admin" }}>
          Dashboard
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Master</Breadcrumb.Item>
        <Breadcrumb.Item active>Edit Role</Breadcrumb.Item>
      </Breadcrumb>

      <RoleForm />
    </div>
  );
};

export default EditRole;
